// extracted by mini-css-extract-plugin
module.exports = {"container":"LKWordCounter_container__CzEE9","filler":"LKWordCounter_filler__3TJrM","fillerFull":"LKWordCounter_fillerFull__2jgYC","label":"LKWordCounter_label__23q_H"};